



import Services1 from './services1.jpg'
import Services2 from './services2jpg.jpg'
import Services3 from './services3.jpg'
import Services4 from './services4.jpg'
import Services5 from './services5.jpg'
import Services6 from './services6.jpg'
import Services7 from './services7.jpg'
import Services8 from './services8.jpg'
import Services9 from './services9.jpg'
import Services10 from './services10.jpg'
import Services11 from './services11.jpg'
import Services12 from './services12.jpg'
import Services13 from './services13.jpg'
import Services14 from './services14.jpg'
import Header from '../Component/header/Header'
import Image1 from './Slide1.jpg';

import Image3 from './Slide3.jpg';
import Image4 from './Slider 4.jpg';
import Image5 from  './Slide5.jpg';
import Image6 from './Slide6.png'


import LogoImage from './tema 2.png';

export default LogoImage;

export const SliderImages = [
  Image1,
  Image5,
 Image6,
  Image4,
  
];

export const muneList = [
    {
      menue_name: "فك وتركيب الاثاث",
      mune_image: Services1,
      description: "خدمة فك وتركيب الأثاث باحترافية لضمان سلامة قطع الأثاث أثناء النقل.",
      article: `
        <h2>فك وتركيب الأثاث باحترافية</h2>
        <p>
          نقدم خدمة فك وتركيب الأثاث باحترافية عالية، حيث نقوم بفك الأثاث بعناية فائقة باستخدام الأدوات المناسبة لتجنب أي تلف أو خدش. نحرص على ترقيم القطع وتغليفها بشكل آمن لتسهيل عملية التركيب في المكان الجديد. فريقنا مدرب على التعامل مع جميع أنواع الأثاث، من الغرف الكاملة إلى الأثاث المكتبي المعقد.
        </p>
        <p>
          نضمن لك تركيب الأثاث بشكل صحيح وسريع، مع الحفاظ على جودة الأثاث وسلامته. نستخدم أحدث الأدوات والتقنيات لضمان تجربة نقل سلسة وخالية من المتاعب.
        </p>
      `
    },
    {
      menue_name: "نقل الاثاث",
      mune_image: Services2,
      description: "خدمة نقل الأثاث بأسطول سيارات مجهزة لضمان وصول الأثاث بسلام.",
      article: `
        <h2>نقل الأثاث بسلامة وأمان</h2>
        <p>
          نقدم خدمة نقل الأثاث بأسطول سيارات مجهزة ومخصصة لنقل الأثاث بأمان. نحرص على تغليف الأثاث بشكل محكم لتجنب أي تلف أثناء النقل. فريقنا مدرب على التعامل مع الأثاث الثقيل والدقيق، مثل الأثاث الزجاجي أو الأثاث العتيق.
        </p>
        <p>
          نضمن لك وصول الأثاث إلى وجهتك بسلامة ودون أي خسائر. نقدم أيضًا خدمة التتبع المباشر لشحنتك لضمان الشفافية والاطمئنان.
        </p>
      `
    },
    {
      menue_name: "تخزين الاثاث",
      mune_image: Services3,
      description: "خدمة تخزين الأثاث في مستودعات آمنة ومجهزة بظروف مناسبة.",
      article: `
        <h2>تخزين الأثاث بأمان</h2>
        <p>
          نقدم خدمة تخزين الأثاث في مستودعات آمنة ومجهزة بظروف مناسبة للحفاظ على الأثاث من التلف أو الرطوبة. المستودعات مجهزة بأنظمة مراقبة وحراسة على مدار الساعة لضمان سلامة الأثاث.
        </p>
        <p>
          يمكنك تخزين الأثاث لفترات قصيرة أو طويلة حسب احتياجاتك. نحرص على تغليف الأثاث بشكل محكم قبل التخزين لتجنب أي تلف.
        </p>
      `
    },
    {
      menue_name: "تغليف الاثاث",
      mune_image: Services5,
      description: "خدمة تغليف الأثاث بمواد عالية الجودة لحمايته أثناء النقل أو التخزين.",
      article: `
        <h2>تغليف الأثاث بمواد عالية الجودة</h2>
        <p>
          نقدم خدمة تغليف الأثاث باستخدام مواد عالية الجودة مثل الفقاعات البلاستيكية والألواح الخشبية لحماية الأثاث من الصدمات والخدوش. نحرص على تغليف كل قطعة بشكل فردي لضمان الحماية الكاملة.
        </p>
        <p>
          نستخدم تقنيات متقدمة في التغليف لتوفير الحماية المثلى للأثاث، خاصة للأثاث الزجاجي أو العتيق.
        </p>
      `
    },
    {
      menue_name: "تركيب الأجهزة الكهربائية",
      mune_image: Services6,
      description: "خدمة تركيب الأجهزة الكهربائية مثل التلفزيونات والمكيفات بأمان واحترافية.",
      article: `
        <h2>تركيب الأجهزة الكهربائية باحترافية</h2>
        <p>
          نقدم خدمة تركيب الأجهزة الكهربائية مثل التلفزيونات والمكيفات والثلاجات بأمان واحترافية. فريقنا مدرب على التعامل مع جميع أنواع الأجهزة الكهربائية وتركيبها وفقًا لأعلى معايير السلامة.
        </p>
        <p>
          نحرص على توفير الأدوات المناسبة والتركيب الصحيح لضمان عمل الأجهزة بكفاءة وأمان.
        </p>
      `
    },
    {
      menue_name: "نقل المكاتب والشركات",
      mune_image: Services8,
      description: "خدمة نقل أثاث المكاتب والشركات بكفاءة وسرعة.",
      article: `
        <h2>نقل المكاتب والشركات بكفاءة</h2>
        <p>
          نقدم خدمة نقل أثاث المكاتب والشركات بكفاءة وسرعة، مع الحفاظ على سلامة الأثاث والأجهزة. نحرص على تنظيم عملية النقل لتقليل وقت التوقف عن العمل.
        </p>
        <p>
          نقدم أيضًا خدمة إعادة تركيب الأثاث في الموقع الجديد لضمان استئناف العمل بسرعة.
        </p>
      `
    },
    {
      menue_name: "تأمين الأثاث أثناء النقل",
      mune_image: Services9,
      description: "خدمة تأمين الأثاث ضد التلف أو الخسارة أثناء النقل.",
      article: `
        <h2>تأمين الأثاث أثناء النقل</h2>
        <p>
          نقدم خدمة تأمين الأثاث ضد التلف أو الخسارة أثناء النقل. نحرص على توفير تغطية تأمينية شاملة لضمان راحة بالك.
        </p>
        <p>
          في حالة حدوث أي تلف أو خسارة، نضمن لك التعويض السريع وفقًا لشروط التأمين.
        </p>
      `
    },
    {
      menue_name: "تنسيق المنزل بعد النقل",
      mune_image: Services10,
      description: "خدمة تنسيق الأثاث في المنزل الجديد لتحقيق أقصى استفادة من المساحة.",
      article: `
        <h2>تنسيق المنزل بعد النقل</h2>
        <p>
          نقدم خدمة تنسيق الأثاث في المنزل الجديد لتحقيق أقصى استفادة من المساحة المتاحة. فريقنا من المصممين المحترفين يساعدك في ترتيب الأثاث بشكل عملي وجمالي.
        </p>
        <p>
          نحرص على تلبية احتياجاتك وتفضيلاتك الشخصية في التنسيق.
        </p>
      `
    },
    {
      menue_name: "نقل العفش الدولي",
      mune_image: Services11,
      description: "خدمة نقل الأثاث بين الدول بأسعار تنافسية وخدمة متميزة.",
      article: `
        <h2>نقل العفش الدولي</h2>
        <p>
          نقدم خدمة نقل الأثاث بين الدول بأسعار تنافسية وخدمة متميزة. نحرص على توفير حلول شاملة لنقل الأثاث بأمان وسرعة.
        </p>
        <p>
          نتعامل مع جميع الإجراءات الجمركية واللوجستية لضمان وصول الأثاث إلى وجهتك بسلامة.
        </p>
      `
    },
    {
      menue_name: "تركيب أنظمة الأرفف والخزائن",
      mune_image: Services13,
      description: "خدمة تركيب الأرفف والخزائن باحترافية لتحقيق أقصى استفادة من المساحة.",
      article: `
        <h2>تركيب أنظمة الأرفف والخزائن</h2>
        <p>
          نقدم خدمة تركيب الأرفف والخزائن باحترافية لتحقيق أقصى استفادة من المساحة المتاحة. فريقنا مدرب على تركيب جميع أنواع الأرفف والخزائن وفقًا لأعلى معايير الجودة.
        </p>
        <p>
          نحرص على توفير حلول تخزين عملية وجمالية تناسب احتياجاتك.
        </p>
      `
    },
    {
      menue_name: "إصلاح الأثاث التالف",
      mune_image: Services14,
      description: "خدمة إصلاح الأثاث الذي يتعرض للتلف أثناء النقل أو التخزين.",
      article: `
        <h2>إصلاح الأثاث التالف</h2>
        <p>
          نقدم خدمة إصلاح الأثاث الذي يتعرض للتلف أثناء النقل أو التخزين. فريقنا من الحرفيين المحترفين قادر على إصلاح جميع أنواع الأثاث، من الخدوش البسيطة إلى التلف الكبير.
        </p>
        <p>
          نحرص على إعادة الأثاث إلى حالته الأصلية بأعلى جودة.
        </p>
      `
    }
  ];


 

